import leftKeyInstruction from '@/features/laneChooserPhaser/assets/lottie/left-key-instruction.json';
import spaceKeyInstruction from '@/features/laneChooserPhaser/assets/lottie/space-key-instruction.json';
import swipeLeftInstruction from '@/features/laneChooserPhaser/assets/lottie/swipe-left-instruction.json';
import swipeUpInstruction from '@/features/laneChooserPhaser/assets/lottie/swipe-up-instruction.json';
import tapInstruction from '@/features/laneChooserPhaser/assets/lottie/tap-instruction.json';
import upKeyInstruction from '@/features/laneChooserPhaser/assets/lottie/up-key-instruction.json';

export type InstructionAnimation = {
	textureKey: string;
	animationData: unknown;
	canvasWidth: number;
	canvasHeight: number;
};

export const INSTRUCTION_ANIMATIONS = {
	leftRightKey: {
		textureKey: 'lane-chooser-instruction-left-right-key',
		animationData: leftKeyInstruction,
		canvasWidth: 480,
		canvasHeight: 200,
	},
	spaceKey: {
		textureKey: 'lane-chooser-instruction-space-key',
		animationData: spaceKeyInstruction,
		canvasWidth: 480,
		canvasHeight: 200,
	},
	swipeLeft: {
		textureKey: 'lane-chooser-instruction-swipe-left',
		animationData: swipeLeftInstruction,
		canvasWidth: 276,
		canvasHeight: 179,
	},
	swipeUp: {
		textureKey: 'lane-chooser-instruction-swipe-up',
		animationData: swipeUpInstruction,
		canvasWidth: 276,
		canvasHeight: 179,
	},
	tap: {
		textureKey: 'lane-chooser-instruction-tap',
		animationData: tapInstruction,
		canvasWidth: 276,
		canvasHeight: 179,
	},
	upKey: {
		textureKey: 'lane-chooser-instruction-up-key',
		animationData: upKeyInstruction,
		canvasWidth: 480,
		canvasHeight: 200,
	},
} satisfies Record<string, InstructionAnimation>;
